import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mpp-device-number-hint',
  templateUrl: './device-number-hint.component.html',
  styleUrls: ['./device-number-hint.component.scss'],
  standalone: false,
})
export class DeviceNumberHintComponent {
  constructor(private dialogRef: MatDialogRef<DeviceNumberHintComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
